/* eslint-disable import/no-cycle */
/* eslint-disable import/no-mutable-exports */
import AuthorizedRoute from './AuthorizedRoute';
import AuthorizedView from './AuthorizedView';
import check from './CheckPermissions';
import Secured from './Secured';

// 每次引入组件之前调用函数传入 currentAuthorize
// 通过组件内部变量来维护 currentAuthorize
let CURRENT = 'NULL';

AuthorizedView.Secured = Secured;
AuthorizedView.AuthorizedRoute = AuthorizedRoute;
AuthorizedView.check = check;

/**
 * use  authority or getAuthority
 * @param {string|()=>String} currentAuthority
 */
const renderAuthorize = currentAuthority => {
  // console.log('Current User Permissions: ',currentAuthority);
  if (currentAuthority) {
    if (currentAuthority.constructor.name === 'Function') {
      CURRENT = currentAuthority();
    }
    if (currentAuthority.constructor.name === 'String') {
      CURRENT = currentAuthority;
    }
    if (currentAuthority.constructor.name === 'Array') {
      CURRENT = currentAuthority;
    }
  } else {
    CURRENT = 'NULL';
  }
  // console.log('current',CURRENT);
  return AuthorizedView;
};

export { CURRENT };
export default renderAuthorize;
